import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const ItemCollectOfflineIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M19 0.25H5C3.48 0.25 2.25 1.48 2.25 3V21C2.25 22.52 3.48 23.75 5 23.75H19C20.52 23.75 21.75 22.52 21.75 21V3C21.75 1.48 20.52 0.25 19 0.25ZM20.25 21C20.25 21.69 19.69 22.25 19 22.25H5C4.31 22.25 3.75 21.69 3.75 21V3C3.75 2.31 4.31 1.75 5 1.75H19C19.69 1.75 20.25 2.31 20.25 3V21Z"
        fill={color}
      />
      <path
        d="M12.31 6.46C12.12 6.35 11.88 6.35 11.68 6.46L7.38001 8.96C7.19001 9.07 7.07001 9.28 7.07001 9.5V14.5C7.07001 14.72 7.19001 14.93 7.38001 15.04L11.68 17.54C11.87 17.65 12.11 17.65 12.31 17.54L16.61 15.04C16.8 14.93 16.92 14.72 16.92 14.5V9.5C16.92 9.28 16.8 9.07 16.61 8.96L12.31 6.46ZM12 7.72L15.09 9.51L12 11.27L8.91001 9.51L12 7.72ZM8.33001 10.62L11.38 12.36V15.91L8.33001 14.14V10.62ZM12.62 15.91V12.36L15.67 10.62V14.14L12.62 15.91Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

ItemCollectOfflineIcon.displayName = 'ItemCollectOfflineIcon';
